import React, { memo, useCallback, useEffect, useState } from 'react';
import NotificationBanner from 'design-system/NotificationBanner';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import useHandleOpenInterestPot from 'features/pots/hooks/useHandleOpenInterestPot';
import { selectHasInterestPots, selectMaximumInterest } from 'features/pots/reducers/selectors';
import { selectIsUserFreeTier, selectIsUserUltimate } from 'features/premium/selectors/tier';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import { isWeb } from '../../../constants';
const InvestUpgradeCTA = memo(() => {
    const isUserInHighestPlan = useAppSelector(selectIsUserUltimate);
    const dispatch = useAppDispatch();
    const [canShowOpenPotsBanner, setCanShowOpenPotsBanner] = useState(false);
    const navigation = useMainStackNavigation();
    const isUserFreeTier = useAppSelector(selectIsUserFreeTier);
    const navigateToOpenInterestPot = useHandleOpenInterestPot();
    const maxInterest = useAppSelector(selectMaximumInterest);
    const didCloseUpgradePotsInterestCTAInInvest = useAppSelector((state) => state.deviceSettings.didCloseUpgradePotsInterestCTAInInvest);
    const hasInterestPots = useAppSelector(selectHasInterestPots);
    const productIdWithTheHighestInterest = useAppSelector((state) => state.pots.productIdWithTheHighestInterest);
    const didCloseUpgradeFXCTAInInvest = useAppSelector((state) => state.deviceSettings.didCloseUpgradeFXCTAInInvest);
    useEffect(() => {
        if (didCloseUpgradeFXCTAInInvest || isUserInHighestPlan) {
            setCanShowOpenPotsBanner(true);
        }
        // runs only once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onUpgrade = useCallback(() => {
        if (isWeb) {
            UpgradeWebModal.show(undefined);
            return;
        }
        navigation.navigateDeprecated('EmmaProModal', { benefitId: 'fxFees' });
    }, []);
    const onCancel = useCallback((key) => () => {
        dispatch(setDeviceSettingsKey(key, true));
    }, []);
    const openPot = useCallback(() => {
        navigateToOpenInterestPot();
    }, []);
    if ((!didCloseUpgradeFXCTAInInvest && !isUserInHighestPlan) || isUserFreeTier) {
        return (<NotificationBanner noMarginBottom noMarginTop={false} positiveButtonTitle="Upgrade" title="Save on your trades 🚀" onPositiveBtnPress={onUpgrade} onCancel={onCancel('didCloseUpgradeFXCTAInInvest')} cancelButtonTitle={isUserFreeTier ? undefined : 'Dismiss'} description="Upgrade your plan to lower your FX fee when trading."/>);
    }
    if (!didCloseUpgradePotsInterestCTAInInvest &&
        canShowOpenPotsBanner &&
        !hasInterestPots &&
        maxInterest &&
        productIdWithTheHighestInterest) {
        return (<NotificationBanner noMarginBottom noMarginTop={false} cancelButtonTitle="Dismiss" onPositiveBtnPress={openPot} positiveButtonTitle="Open pot" onCancel={onCancel('didCloseUpgradePotsInterestCTAInInvest')} title={maxInterest ? `Earn up to ${maxInterest}% AER! 🚀` : 'Earn interest! 🚀'} description="Set up your Interest Pots today. Interest paid daily, FSCS eligible for up to £120,000 per bank."/>);
    }
    return null;
});
export default memo(InvestUpgradeCTA);
